import React from 'react';
import { Spin } from 'antd';

function SpinnerBlock() {
  return (
    <div
      style={{
        height: '10vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'transparent',
      }}
    >
      <Spin size="large" />
    </div>
  );
}

export default SpinnerBlock;
